var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.fieldsAccessData) ? _c('actionComponent', {
    attrs: {
      "ShipmentDetails": _vm.alldata,
      "fieldsAccessData": _vm.fieldsAccessData,
      "images": _vm.images
    },
    on: {
      "prevPage": _vm.Backinvestigation,
      "fetchDeails": _vm.getData,
      "updateDetails": _vm.updateDetails
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45bac9dd","hasScoped":false}!./src/views/components/B2B/CLTExecutive/EditCLTExecutivepage/EditCLTExecutivepage.component.html
// module id = 582
// module chunks = 1